import { UserService } from "../../../../common/services/api/resources/user/user.service";
import { UserAddressService } from "../../../../common/services/api/resources/userAddress/user-address.service";
import { SignUpUserService } from "./signup-user.service";
import { SignUpUserAddressService } from "./signup-user-address.service";

export const SignUpLifeCycleHookApiResource = () => {
  return [
    { provide: UserService, useClass: SignUpUserService },
    { provide: UserAddressService, useClass: SignUpUserAddressService }
  ];
};
